const EnumStatusInbox = {
  LIDO: 1,
  NAO_LIDO: 2,
  CLICADO: 3
}

export { EnumStatusInbox }
